export default __webpack_public_path__ + "static/media/b6.24996b75.png";